import ViewRespondentDialog from './viewRespondentDialog.container';

export default ViewRespondentDialog;
